import { type NavigateOptions, useNavigate, } from "react-router";


export declare type IHistory = {
	navigate?: ReturnType<typeof useNavigate>;
	push: (path: string, options?: NavigateOptions ) => void;
};

/** custom global history object which pushes paths to the useNavigate hook. */
export const History: IHistory = {
	navigate: undefined,
	push: (path: string, options?: NavigateOptions ) => {
		if(typeof History.navigate === "function") {
			History.navigate(path, options);
			return;
		}
		throw new Error("history push called before instantiation of the history object");
	},
};

export const NavigateSetter = () => {
	History.navigate = useNavigate();
	return null;
};
